define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll', 'jump'],
    function ($, transit, modernizr, container, preloader, router, scroll, jumpFactory) {

        var module = (function () {

            var name = 'module-company-content';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            const jump = jumpFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {
                currentTeam: null,
                teamAnim: false
            };

            view.startup = function () {
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.companyContentHeaderCls, 'animate__slideInDown', 'company-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.companyContentLogoCls, 'animate__zoomIn', 'company-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.companyContentDescriptionCls, 'animate__fadeIn', 'company-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.companyContentSubheaderCls, 'animate__zoomIn', 'company-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.companyContentBarSwitchManagementCls, 'animate__fadeInRight', 'company-content', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.companyContentBarSwitchProductionCls, 'animate__fadeInLeft', 'company-content', {});

                view.privateVars.currentTeam = view.publicVars.currentTeam;


                $(view.publicVars.cssId.anim.companyContentPersonBoxOuterTeamManagementCls).each(function (item) {

                    const id = container.getData($(this)[0], 'id');

                    let cls = 'animate__slideInLeft';

                    if (id % 2 === 0) {
                        cls = 'animate__slideInRight';
                    }

                    scroll.registerAnimatedElement(view.publicVars.cssId.anim.companyContentPersonBoxOuterTeamManagementCls + id, cls, 'company-content', {});
                });

                $(view.publicVars.cssId.anim.companyContentPersonBoxOuterTeamProductionCls).each(function (item) {

                    const id = container.getData($(this)[0], 'id');

                    let cls = 'animate__slideInLeft';

                    if (id % 2 === 0) {
                        cls = 'animate__slideInRight';
                    }

                    scroll.registerAnimatedElement(view.publicVars.cssId.anim.companyContentPersonBoxOuterTeamProductionCls + id, cls, 'company-content', {});
                });
            };

            view.bind = function () {
                $(view.publicVars.cssId.companyContentBarSwitchCls).click(function (e) {
                    e.preventDefault();
                    const team = container.getData($(this)[0], 'team');

                    if(!view.privateVars.teamAnim || team !== view.privateVars.currentTeam) {
                        view.privateVars.teamAnim = true;
                        view.methods.switchTeam(team);
                    }

                });
            };

            view.methods = {
                setCallbacks: (callbacks) => {
                    view.privateVars.callbacks = callbacks;
                },

                switchTeam: (team) => {
                    if(team !== view.privateVars.currentTeam) {

                        $(view.publicVars.cssId.companyContentBarSwitchCls + '-' + view.privateVars.currentTeam).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                        $(view.publicVars.cssId.companyContentBarSwitchCls + '-' + team).addClass(view.publicVars.cssId.isActiveCls.substr(1));

                        $(view.publicVars.cssId.companyContentTeamCls + '-' + view.privateVars.currentTeam).removeClass(view.publicVars.cssId.isActiveCls.substr(1));

                        const headerHeight = $(view.publicVars.cssId.headerCls).outerHeight();

                        jump.jumpTo(view.publicVars.cssId.companyContentTeamWrapperCls, { speed: 300, modifier: -headerHeight });

                        $(view.publicVars.cssId.companyContentTeamCls + '-' + team).fadeIn(300, function () {
                            $(view.publicVars.cssId.companyContentTeamCls + '-' + team).removeAttr('style');
                            $(view.publicVars.cssId.companyContentTeamCls + '-' + team).addClass(view.publicVars.cssId.isActiveCls.substr(1));

                            router.route(view.publicVars.baseUrl + '/' + team);

                            scroll.handleCurrentScrollPosition();

                            view.privateVars.teamAnim = false;
                            view.privateVars.currentTeam = team;
                        });
                    }
                }
            };

            /* custom events */

            // pubSub.subscribe('view/updateCharacterContent', view.methods.updateCharacterContent);

            //pubSub.subscribe('view/updateSuccessLikes', view.methods.updateSuccessLikes);
            //pubSub.subscribe('view/updateSuccessViews', view.methods.updateSuccessViews);

            /* public methods */
            return {
                init: function (options, callbacks) {
                    view.methods.setCallbacks(callbacks);
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();


        return module;

    });